import { render } from "./CS_strategic_design.vue?vue&type=template&id=2d3d0158&scoped=true"
import script from "./CS_strategic_design.vue?vue&type=script&lang=js"
export * from "./CS_strategic_design.vue?vue&type=script&lang=js"

import "./CS_strategic_design.vue?vue&type=style&index=0&id=2d3d0158&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3d0158"]])

export default __exports__